import type React from 'react'

import { MarkerF, type MarkerProps } from '@react-google-maps/api'

import { svgRequestMarker } from '@/components/atoms/MapSvgMarker/svgRequestMarker.ts'

export type CompletedRequestDestinationMarkerProps = { children?: React.ReactNode } & Omit<MarkerProps, 'icon'>

export const CompletedRequestDestinationMarker: React.FC<CompletedRequestDestinationMarkerProps> = ({
  children,
  ...props
}) => (
  <MarkerF
    {...props}
    icon={{
      url: `data:image/svg+xml;utf-8,${encodeURIComponent(svgRequestMarker('completed'))}`,
      scaledSize: new google.maps.Size(36, 36),
      labelOrigin: new google.maps.Point(18, 14),
      // Adjustments because of the shadow
      anchor: new google.maps.Point(18, 32),
    }}>
    {children}
  </MarkerF>
)
